import React from 'react';
import { useEventChatSessions } from '../../../data/hooks/chat/useEventChatSessions';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useEventNotifications } from '../../../data/hooks/notifications/useEventNotifications';
import ButtonLink from '../../elements/ButtonLink';
import EmptyScreenContentPlaceholder from '../../elements/EmptyScreenContentPlaceholder/EmptyScreenContentPlaceholder';
import ScreenTitle from '../../elements/ScreenTitle/ScreenTitle';
import ScrollableList from '../../elements/ScrollableList';
import ToolbarLayout from '../../elements/ToolbarLayout';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadChatSessions from '../../loaders/LoadChatSessions';
import ErrorBoundary from '../../validate/ErrorBoundary';
import Screen from '../Screen';
import StartNetworkingFooterButton from '../StartNetworking/StartNetworkingFooterButton/StartNetworkingFooterButton';
import ChatSessionListItem from './ChatSessionListItem';
import { unreadChatNotificationsFilter } from './unreadChatNotificationsFilter';

function EventChatSessions(props) {
    const {} = props,
        event = useEvent(),
        i18n = useI18n(),
        chatSessions = useEventChatSessions(event.id),
        unreadNotifications = useEventNotifications(event.id, {
            filter: unreadChatNotificationsFilter,
        });

    const header = (
            <div>
                <TopBarEvent event={event} chat="chat" />
                <ScreenTitle event={event} screen={i18n['label.chat']} />
                <hr />
            </div>
        ),
        footer = (
            <div className="content">
                <ToolbarLayout>
                    <StartNetworkingFooterButton event={event} />
                </ToolbarLayout>
            </div>
        );

    return (
        <Screen header={header} footer={footer}>
            {chatSessions.length ? (
                <ScrollableList savePosition={'eventChatSessions-' + event.id}>
                    {chatSessions.map((chatSession) => (
                        <ChatSessionListItem key={chatSession.id} chatSession={chatSession} notifications={unreadNotifications} />
                    ))}
                </ScrollableList>
            ) : (
                <EmptyScreenContentPlaceholder event={event} icon="/img/event_chat.png" title={i18n['label.chat']} label={i18n['label.tip.no-chat']} />
            )}
        </Screen>
    );
}

export default (props) => (
    <LoadChatSessions>
        <ErrorBoundary altRoute="..">
            <EventChatSessions {...props.match.params} />
        </ErrorBoundary>
    </LoadChatSessions>
);
